<script>
  export let data;
  export let slideWidth;

  import Icon from "../Icon.svelte";
  import Title from "../Title.svelte";
  import Tooltip from "../Tooltip.svelte";

  import { windowWidth, isMobile } from "../../stores/global.js";

  $: paraHeight = null;
  $: iconHeight = null;

  $: finalEventHeight = Math.max(paraHeight, iconHeight);

  let active;

  const setActive = function () {
    active = data.title;
  };

  const noneActive = function () {
    active = null;
  };
</script>

<div
  on:click={() => {
    active == data.title ? noneActive() : setActive();
  }}
  class={active == data.title ? "active" : ""}
>
  <div
    class="top-level-content {data.size}"
    style="height: {finalEventHeight}px;"
  >
    <Icon {data} bind:iconHeight>
      <Title
        size={data.size}
        title={data.title}
        active={true}
        activeViaHover={true}
        {slideWidth}
        eventIndex={2}
        bind:paraHeight
      />
    </Icon>
  </div>
  {#if active == data.title}
    <Tooltip
      type={data.type}
      width={$isMobile
        ? $windowWidth * 0.95 + "px"
        : slideWidth * 2 * 1.5 > 650
        ? 650
        : slideWidth * 2 * 1.5 + "px"}
      text={data.description}
      isMobile={false}
    />
  {/if}
</div>

<style>
  .event {
    display: flex;
    flex-direction: column;
    place-items: center;
    cursor: pointer;
  }

  .top-level-content {
    margin: 7px 0;
    display: flex;
  }

  :global(.example-event-container .active .icon-container .icon) {
    animation: rotate 500ms ease;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
